import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { maintenanceAPI, regulatoryAPI } from '../services/api';
import { useAuth } from './AuthContext';

const AlertsContext = createContext({ criticalAlerts: 0, upcomingDeadlines: 0, refresh: () => {} });

export const AlertsProvider = ({ children }) => {
  const { user } = useAuth();
  const [criticalAlerts, setCritical]     = useState(0);
  const [upcomingDeadlines, setDeadlines] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const [alerts, filings] = await Promise.all([
        maintenanceAPI.alerts({ status: 'open', severity: 'critical' }),
        regulatoryAPI.list({ status: 'pending' }),
      ]);
      setCritical((alerts.data.data || []).length);
      const filingList = filings.data.data.items || filings.data.data || [];
      setDeadlines(filingList.filter(f => f.days_remaining >= 0 && f.days_remaining <= 30).length);
    } catch { /* silent */ }
  }, [user]);

  useEffect(() => {
    refresh();
    // Poll every 5 minutes
    const interval = setInterval(refresh, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [refresh]);

  return (
    <AlertsContext.Provider value={{ criticalAlerts, upcomingDeadlines, refresh }}>
      {children}
    </AlertsContext.Provider>
  );
};

export const useAlerts = () => useContext(AlertsContext);
